import { render, staticRenderFns } from "./glsz.vue?vue&type=template&id=03a3a20c&scoped=true"
import script from "./glsz.vue?vue&type=script&lang=js"
export * from "./glsz.vue?vue&type=script&lang=js"
import style0 from "./glsz.vue?vue&type=style&index=0&id=03a3a20c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a3a20c",
  null
  
)

export default component.exports